<template>
  <div
    class="bg-surface-container-low group rounded-medium relative cursor-pointer overflow-hidden p-3 first:rounded-t-xl last:rounded-b-xl"
    :class="[expanded && 'border-outline-variant my-2 border shadow']"
  >
    <div class="flex flex-row">
      <h4 class="text-body-medium text-on-surface-variant mr-2 grow">
        {{ question.content }}
      </h4>
      <span class="text-label-medium text-on-surface-variant ml-1">({{ numberOfFeedbacks }})</span>
    </div>
    <TextFeedbacksForPerspectives
      v-if="expanded"
      class="mt-8"
      :perspectives="textFeedbacks.perspectives"
    />
    <BaseStateLayer />
  </div>
</template>
<script lang="ts" setup>
  import BaseStateLayer from '../../../../core/components/base/state-layer/BaseStateLayer.vue'
  import { computed } from 'vue'
  import type { TextAnalysis } from '@/core/models/surveys-analytics'
  import TextFeedbacksForPerspectives from './TextFeedbacksForPerspectives.vue'

  interface Props {
    textFeedbacks: TextAnalysis
    expanded: boolean
  }

  const props = defineProps<Props>()

  const question = computed(() => {
    return props.textFeedbacks.question
  })

  const numberOfFeedbacks = computed(() => {
    return props.textFeedbacks.perspectives.reduce(
      (total, perspective) => total + perspective.numberOfFeedbacks,
      0,
    )
  })
</script>
